import request from '@/utils/request'

 // 查询MPS基础数据维护列表
  export function apiScpMpsBasicDataList (query) {
    return request({
      url: `/scp/scpMpsBasicData/list`,
      method: 'get',
      params: query
    })
  }
 // 新增MPS基础数据维护列
 export function apiNewScpMpsBasicData (query) {
    return request({
      url: `/scp/scpMpsBasicData`,
      method: 'post',
      data: query
    })
  }
   // 查询日销售/发货比例列表
 export function apiScpMpsDailySalesDeliveryRatioList (query) {
  return request({
    url: `/scp/scpMpsDailySalesDeliveryRatio/list`,
    method: 'get',
    params: query
  })
}
   // 查询日销售/发货比例列表
   export function apiScpMpsBasicData (query) {
    return request({
      url: `/scp/scpMpsBasicData`,
      method: 'put',
      data: query
    })
  }
   // 删除查询日销售/发货比例列表
   export function apiDelScpMpsBasicData (id) {
    return request({
      url: `/scp/scpMpsBasicData/${id}`,
      method: 'delete'
    })
  }
     // 更新日销售/发货比例列表
 export function apiUpdateScpMpsDailySalesDeliveryRatio (query) {
  return request({
    url: `/scp/scpMpsDailySalesDeliveryRatio`,
    method: 'put',
    data: query
  })
}

   // 查询订单满足率列表
   export function apiScpMpsOrderFulfillmentRate (query) {
    return request({
      url: `/scp/scpMpsOrderFulfillmentRate/list`,
      method: 'get',
      params: query
    })
  }
     // 更新订单满足率列表
     export function apiUpdateScpMpsOrderFulfillmentRate (query) {
      return request({
        url: `/scp/scpMpsOrderFulfillmentRate`,
        method: 'put',
        data: query
      })
    }
     // 删除订单满足率
     export function apiDeleteScpMpsOrderFulfillmentRate (id) {
      return request({
        url: `/scp/scpMpsOrderFulfillmentRate/${id}`,
        method: 'delete'
      })
    }
     // 删除日销售
     export function apiDeleteScpMpsDailySalesDeliveryRatio (id) {
      return request({
        url: `/scp/scpMpsDailySalesDeliveryRatio/${id}`,
        method: 'delete'
      })
    }
